import { render, staticRenderFns } from "./SPIDAuth.vue?vue&type=template&id=7c0989fa"
import script from "./SPIDAuth.vue?vue&type=script&lang=js"
export * from "./SPIDAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports